<template>
  <div class="relative flex cursor-pointer flex-col gap-1">
    <div class="relative w-full overflow-hidden">
      <div class="flex flex-col gap-1">
        <p
          data-testid="product-card-product-brand"
          class="truncate text-md font-semibold text-gray-900"
        >
          {{ brand }}
        </p>
        <p
          data-testid="product-card-product-name"
          class="truncate text-sm text-anthracite-800"
        >
          {{ name }}
        </p>
        <p
          data-testid="product-card-product-name"
          class="truncate text-sm text-gray-600"
        >
          {{ nonSoldOutSiblings.length }}
          {{ $t('product_details.colors', nonSoldOutSiblings.length) }}
        </p>
      </div>
    </div>
    <SFProductPrice
      v-if="price"
      :promotion="promotion"
      :price="price"
      :lowest-prior-price="lowestPriorPrice"
      :show-price-from="showPriceFrom"
      class="left-2 md:left-0"
    />
  </div>
</template>

<script setup lang="ts">
import type { Product } from '@scayle/storefront-nuxt'
import { computed } from 'vue'
import SFProductPrice from '../SFProductPrice.vue'
import { useProductBaseInfo } from '~/composables'
import { getPromotionForProduct } from '~/utils'
import { useCurrentPromotions } from '#storefront/composables'

const { product } = defineProps<{
  product: Product
  showSiblings?: boolean
}>()

const { brand, name, price, lowestPriorPrice, nonSoldOutSiblings } =
  useProductBaseInfo(() => product)

const showPriceFrom = computed(
  () => product.priceRange?.min.withTax !== product.priceRange?.max.withTax,
)

const promotionData = useCurrentPromotions()

const promotion = computed(() => {
  return getPromotionForProduct(
    product,
    promotionData.data?.value?.entities ?? [],
  )
})
</script>
